
import {module} from '../app';

module.config(function ($httpProvider) {
    $httpProvider.interceptors.push('techpadVersioningIntercept');
  })
  .factory('techpadVersioningIntercept', ['appVersionNumber', 'apiUrl', function (appVersionNumber, apiUrl) {
    return {
      'request': function (config) {
        if (config.url.indexOf(apiUrl) == -1) {
          config.headers.TechpadVersion = appVersionNumber;
        }
        return config;
      }
    };
  }]);



// WEBPACK FOOTER //
// ./src/scripts/services/techpadVersioningIntercept.js